/**
 * helper function to return the default value
 * 
 * uses defaultValue in extra. If set to static then use staticValue, if not fetch the one from the user field.
 * 
 * TODO: Implement calculation
 * 
 * @param {*} param0 
 */
import filterString from '../common3/filterString'


const setDefaultValue = ({extra, user = {}, context, props}) => {
    const { defaultValue,staticValue } = extra

    switch( defaultValue ) {
        case 'static' : {
            return filterString(staticValue,props,context) 
        }
        default: 
            return user && user[defaultValue]
    }

}

export default setDefaultValue